import { Component, OnInit, Input, ViewChild, TemplateRef, EventEmitter, Output } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BsModalService, BsModalRef } from 'ngx-bootstrap';
import { Observable } from 'rxjs/Observable';
import { Store } from '@ngrx/store';
import { ToasterService } from 'angular2-toaster';
import swal from 'sweetalert2';
import * as _ from 'lodash';
import { FormBuilder, FormGroup, FormControl, AbstractControl, Validators } from '@angular/forms';
import * as moment from 'moment';
import { Subject }           from 'rxjs/Subject';
// Observable class extensions
import 'rxjs/add/observable/of';

// Observable operators
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/debounceTime';
import 'rxjs/add/operator/distinctUntilChanged';

import { CommonService, PurchaseReturnService, SubscribeService } from '../../../services/index';
import { PurchaseReturnModel } from '../../../model/index';

@Component({
    selector: 'add-purchase-return-tab',
    templateUrl: './addPurchaseReturn.component.html'
})
export class AddPurchaseReturnComponent implements OnInit {
    private searchTerms = new Subject<string>();

    @Input('tabTitle') title: string;
    @Input() active = false;
    @Input() isCloseable = false;
    @Input() dataContext;
    _params: any[] = [];
    @Input() set params(val: any[]) {
        this._params = val;
        this.setPageData();
    }


    statusCusCtrl: FormControl;
    serialNoCtrl: FormControl;
    potCusCtrl: FormControl;
    clientCtrl: FormControl;
    referenceCtrl: FormControl;
    potCusOptList: any[];
    statusList: any[];
    clientList: any[];
    prodList: any[];
    page = {
        limit: 20,
        count: 0,
        offset: 0,
        orderBy: 'purchase_id',
        orderDir: 'asc'
    };
    purchaseReturnDetails = [];
    columns = [];
    filteredItems: Observable<any[]>;
    filteredReference: Observable<any[]>;
    @Input() returngriddata: PurchaseReturnModel[] = [];
    @Input() purchaseReturnData: PurchaseReturnModel[] = [];
    @ViewChild('clientAutoComp') clientAutoComp;
    @ViewChild('prodAutoComp') prodAutoComp;
    // @ViewChild('singleClientDetails') singleClientDetails;
    @ViewChild('searchComponent') searchComponent;
    @ViewChild('snoTemplate') snoTemplate: TemplateRef<any>;
    @ViewChild('editDeleteTemplate') editDeleteTemplate: TemplateRef<any>;
    itemList: any[] = [];
    isLoading: boolean = false;
    minDate: any;

    constructor(
        private modalService: BsModalService,
        public toasterService: ToasterService,
        private commonService: CommonService,
        private purchaseReturnService: PurchaseReturnService,
        public subscribeService: SubscribeService)
    {
        this.potCusCtrl = new FormControl();
        this.statusCusCtrl = new FormControl();
        //this.serialNoCtrl = new FormControl();
        this.potCusOptList = ['Yes', 'No'];
        this.statusList = ['Yes', 'No'];

        //this.clientCtrl = new FormControl();

        //FOR AUTO COMPLETE VALIDATION --- HA MODEL
        function hasValidHaModel(input: FormControl) {
            let ModelID = input.value, retVal = null;
            if (ModelID == "") {
                retVal = { inValidHaModel: true };
            }
            if (ModelID && typeof ModelID === 'string') {
                retVal = { inValidHaModel: true };
            }
            return retVal;
        }
        this.serialNoCtrl = new FormControl('', [
            Validators.required,
            hasValidHaModel.bind(this)
        ]);

        this.referenceCtrl = new FormControl();
        this.filteredReference = this.referenceCtrl.valueChanges
            .startWith(null)
            .map(name => name ? this.filterItems(name) : this.itemList.slice());
    }

    ngOnInit(): void {
        let that = this;
        this.filteredItems = this.searchTerms
            .debounceTime(300)        // wait 300ms after each keystroke before considering the term
            .distinctUntilChanged()   // ignore if next search term is same as previous
            .switchMap(term => term   // switch to new observable each time the term changes
                // return the http search observable
                ? this.commonService.loadClientList(term, 'walkIn')
                // or the observable of empty heroes if there was no search term
                : Observable.of<any[]>([]))
            .catch(error => {
                // TODO: add real error handling
                console.log(error);
                return Observable.of<any[]>([]);
            });

        this.filteredItems.subscribe(($e) => {
            that.clientList = $e;
        });

        this.columns = [
            { name: 'SNo', prop: 'sno',width:50,minWidth:50, maxWidth: 50, sortable: false, cellTemplate: this.snoTemplate },
            { name: 'Model', prop: 'name',width:120,minWidth:120, maxWidth: 120, sortable: false, cellClass: 'cell-left' },
            { name: 'Serial No', prop: 'serial_no',width:100,minWidth:100, maxWidth: 100, sortable: false, cellClass: 'cell-left' },
            { name: 'Brand', prop: 'brand_name',width:100,minWidth:100, maxWidth: 100, sortable: false, cellClass: 'cell-left' },
            { name: 'Brand Model', prop: 'brand_model_name',width:140,minWidth:140, maxWidth: 140, sortable: false, cellClass: 'cell-left' },
            { name: 'Family', prop: 'family_name',width:100,minWidth:100, maxWidth: 100, sortable: false, cellClass: 'cell-left' },
            { name: 'Series', prop: 'series_name',width:100,minWidth:100, maxWidth: 100, sortable: false, cellClass: 'cell-left' },
            { name: 'Performance', prop: 'performance_name',width:110,minWidth:110, maxWidth: 110, sortable: false, cellClass: 'cell-left' },
            { name: 'Power', prop: 'power_name',width:100,minWidth:100, maxWidth: 100, sortable: false, cellClass: 'cell-left' },
            { name: 'Battery', prop: 'battery_name',width:100,minWidth:100, maxWidth: 100, sortable: false, cellClass: 'cell-left' },
            { name: 'Color', prop: 'color_name', width: 120, minWidth: 120, maxWidth: 120, sortable: false, cellClass: 'cell-left' },
            { name: 'Tele Audiology', prop: 'tele_audiology',width:120,minWidth:120, maxWidth: 120, sortable: false, cellClass: 'cell-left' },
            { name: 'MRP', prop: 'mrp',width:60,minWidth:60, maxWidth: 60, sortable: false, cellClass: 'cell-right' },
            { name: 'Qty', prop: 'qty',width: 50,minWidth: 50, maxWidth: 50, sortable: false, cellClass: 'cell-right' },
            { name: 'Amount', prop: 'total_amount', width: 80, minWidth: 80, maxWidth: 80, sortable: false, cellClass: 'cell-right' },
            { name: 'Action', prop: 'sno',width:60,minWidth:60, maxWidth: 60, sortable: false, cellClass: 'cell-center', cellTemplate: this.editDeleteTemplate }
       ];
        if (this._params['mode'] == 'Add') {
            this.minDate = new Date(new Date().getFullYear(),
                new Date().getMonth(),
                new Date().getDate());

            this.purchaseReturnData['date'] = new Date();


            this.searchComponent.purchaseSearchEmit.subscribe(($e) => {
                that.purchaseReturnData['purchase_id'] = $e['purchase_id'];
                that.purchaseReturnData['purchase_no'] = $e['purchase_no'];
                that.purchaseReturnData['purchase_date']   = $e['date'];
                that.purchaseReturnData['disp_date']   = $e['disp_date'];
                that.purchaseReturnData['quantity']    = $e['quantity'];
                that.purchaseReturnData['party_id']    = $e['party_id'];
                that.purchaseReturnData['party_name']  = $e['party_name'];
                //that.prodList = $e['prodRes'];
                that.returngriddata = [];
                that.purchaseReturnDetails = [];
                that.purchaseReturnData['mode'] = 'Add';
                that.getPurchaseDetails(that.purchaseReturnData);
            });
        }
        if (this._params['mode'] == 'Add') {
            this.loadAutoNumber();
        }

        this.purchaseReturnData['random_no'] = this.getRandomInt(1, 500);
    }

    loadAutoNumber(): void {
        let that = this,
            data = {
                account_type: 'purchaseReturn',
                date: moment(this.purchaseReturnData['date']).format('YYYY-MM-DD')
            };
        this.commonService
            .getAutoNumber(data)
            .then(function(res: any) {
                if (res['success']) {
                    that.purchaseReturnData['auto_no'] = res['auto_no'];
                } else {
                    var toast = {
                        type: 'error',
                        title: 'ERROR',
                        body: 'Oops, Something Went Wrong'
                    };
                    that.toasterService.pop(toast);
                }
            });
    }

    setPageData(): void {

        if (this._params != undefined) {
            let mode = this._params['mode'];
            if (mode == 'Edit') {
                let data = this._params;
                this.getPurchaseReturnDetails(data);
                this.purchaseReturnData = this._params;
                this.purchaseReturnData['auto_no'] = this._params['auto_no'];
                this.purchaseReturnData['date'] = new Date(this._params['addedon']);//new Date();
                // this.singleClientDetails.loadClient(this.purchaseReturnData['client_id']);
            }
        }
    }

    getPurchaseReturnDetails(data: any): void {
        let that = this,
            params = {
                purchase_id: data.purchase_id,
                return_id: data.return_id,
                mode: data.mode
            };
        this.purchaseReturnService
            .getReturnDetails(params)
            .then(function(res: any) {
                that.page.count = res.totCnt;
                that.purchaseReturnDetails = res.data;
                that.prodList = res.prodRes;
            });
    }

    getPurchaseDetails(data: any): void {
        let that = this,
            params = {
                purchase_id: data.purchase_id,
                mode: data.mode
            };
        this.purchaseReturnService
            .getPurchaseModelDetails(params)
            .then(function(res: any) {
                that.page.count = res.totCnt;
                // that.purchaseReturnDetails = res.data;
                that.prodList = res.prodRes;
            });
    }
    getRandomInt(min, max) {
        return Math.floor(Math.random() * (max - min + 1)) + min;
    }

    searchClient(query: string) {
        this.searchTerms.next(query);
    }

    onEnterKeyPressed(nextEl: string): void {
        if (_.isEmpty(document.getElementById(this.purchaseReturnData['random_no'] + '_' + nextEl))) {
            nextEl = 'followup_status';
        }
        $('#' + this.purchaseReturnData['random_no'] + '_' + nextEl).focus();
    }

    displayFn(client_id: any) {
        if (this.clientList != undefined) {
            if (client_id && this.clientList.length > 0) {
                let fitem = _.find(this.clientList, { 'client_id': client_id });
                this.purchaseReturnData['sale_no'] = fitem.sale_no;
                this.purchaseReturnData['sale_date'] = fitem.sale_date;
                this.purchaseReturnData['item'] = fitem.item;
                this.purchaseReturnData['quantity'] = fitem.quantity;
                this.purchaseReturnData['client_no'] = fitem.client_no;
                this.purchaseReturnData['client_name'] = fitem.client_name;
                this.purchaseReturnData['mobile'] = fitem.mobile; //ANOTHER FIELD
                this.purchaseReturnData['reference_name'] = fitem.reference_name;
                //  this.singleClientDetails.loadClient(fitem);//TO LOAD CLIENT OBJECT
                return fitem['client_no'];
            }
        }
        return '';
    }
    //  for loading the product and qunatity on change function
    displayProd(model_id: any) {
        this.onChangeProd(model_id);
        if (this.prodList != undefined) {
            if (model_id && this.prodList.length > 0) {
                let fitem = _.find(this.prodList, { 'model_id': model_id });
                //TO LOAD CLIENT OBJECT
                return fitem['name'];
            }
        }
        return '';
    }
    onChangeProd(model_id) {

        let that = this;
        let fitem = _.find(this.prodList, { 'model_id': model_id });
        //TO LOAD CLIENT OBJECT

        that.returngriddata['name'] = fitem['name'];
        that.returngriddata['quantity'] = fitem['quantity'];
        that.returngriddata['mrp'] = fitem['mrp'];
        that.returngriddata['serial_no'] = fitem['serial_no'];
        that.returngriddata['brand_name'] = fitem['brand_name'];
        that.returngriddata['brand_model_name'] = fitem['brand_model_name'];
        that.returngriddata['family_name'] = fitem['family_name'];
        that.returngriddata['series_name'] = fitem['series_name'];
        that.returngriddata['performance_name'] = fitem['performance_name'];
        that.returngriddata['power_name'] = fitem['power_name'];
        that.returngriddata['battery_name'] = fitem['battery_name'];
        that.returngriddata['color_name'] = fitem['color_name'];
        that.returngriddata['color_id'] = fitem['color_id'];
        that.returngriddata['tele_audiology'] = fitem['tele_audiology'];
        that.returngriddata['brand_id'] = fitem['brand_id'];
        that.returngriddata['brand_model_id'] = fitem['brand_model_id'];
        that.returngriddata['family_id'] = fitem['family_id'];
        that.returngriddata['series_id'] = fitem['series_id'];
        that.returngriddata['performance_id'] = fitem['performance_id'];
        that.returngriddata['power_id'] = fitem['power_id'];
        that.returngriddata['battery_id'] = fitem['battery_id'];
        that.returngriddata['stock_type'] = fitem['stock_type'];
    }
    // end
    resetWalkInData() {
        if (this._params['mode'] == 'Add') {
            this.purchaseReturnData = [];
            this.purchaseReturnData['date'] = new Date();
        }
    }
    /*  loadFollowUpStatus(): void {
          let that = this;

          that.commonService
              .getFollowUpStatusList({})
              .then(function(res: any) {
                  that.statusList = res.data;
              });
      }*/
    displayStatusFn(fol_id: any) {
        if (this.statusList != undefined) {
            if (fol_id && this.statusList.length > 0) {
                let folObj = _.find(this.statusList, { 'fol_id': fol_id });
                return folObj['name'];
            }
        }
        return '';
    }


    filterItems(name: string) {
        name = _.escapeRegExp(name);
        return this.itemList.filter(item => (new RegExp(name, 'gi').test(item.client_code) || new RegExp(name, 'gi').test(item.name)));
    }

    displayRef(item_id: number) {
        if (item_id && this.itemList.length > 0) {
            let fitem = _.find(this.itemList, { 'ref_id': item_id });
            return fitem['name'];
        }
        return '';
    }
    onDeletPurchaseReturnEntry(row: any): void {
        let that = this,
            mode = this._params['mode'];


        if (mode == 'Add') {
            this.purchaseReturnDetails.splice(this.purchaseReturnDetails.indexOf(row), 1);

            that.calGrossTotal();
        } else {
            let params = {
                name: row['name'],
                model_id: row['model_id'],
                serial_no: row['serial_no'],
                qty: row['qty'],
                return_id: row['return_id']
            };

            //  this.salesBillgriddata = [];

            this.purchaseReturnService
                .deleteGridList(params)
                .then(function(res: any) {
                    that.isLoading = false;
                    if (res.success) {
                        that.purchaseReturnDetails.splice(that.purchaseReturnDetails.indexOf(row), 1);
                        swal('SUCCESS', res.message, 'success');
                            that.calGrossTotal();

                        // that.getServiceWalkInList()

                    } else {

                        swal('ERROR', res.message, 'error');
                    }
                });
        }
    }
    addPurchaseReturnEnrty(): void {

        let that = this,
            toast = {
                type: 'warning',
                title: 'WARNING'
            },
            mode = this._params['mode'],
            modelID = this.returngriddata['model_id'],
            availQty = this.returngriddata['quantity'],
            Serial = this.returngriddata['serila_no'],
            modelName = this.returngriddata['name'],
            Mrp = this.returngriddata['mrp'],
            enteredQty = this.returngriddata['qty'];



        if (!_.isEmpty(_.toString(modelID))) {

            let preTestID = _.find(this.purchaseReturnDetails, { 'model_id': modelID });

            if (preTestID) {
                toast['body'] = 'Model : ' + modelName + ' Already Exists';
                this.toasterService.pop(toast);
                return;
            }

            else if (_.isEmpty(_.toString(enteredQty))) { // 11 > 10
                toast['body'] = 'Please Enter  Quantity';
                this.toasterService.pop(toast);
                return;
            }

            
            else if (_.toNumber(enteredQty) > _.toNumber(availQty)) { // 11 > 10
                toast['body'] = 'Please Enter Valid Quantity. It should less than or equal to  Purchase Quantity';
                this.toasterService.pop(toast);
                return;
            }

            else if (_.toNumber(enteredQty) == 0) { // 11 > 10
                toast['body'] = 'Please Enter Valid Quantity. 0 is not Valid';
                this.toasterService.pop(toast);
                return;
            }

            if (mode == 'Add') {

                let testDet = Object.assign({}, this.returngriddata);
                this.purchaseReturnDetails.push(testDet);
                this.returngriddata = [];
                this.returngriddata['amount'] = 0;
                that.page.count = this.purchaseReturnDetails.length;
                that.calGrossTotal();

                //this.serialNoList = [];
            } else if (mode == 'Edit') {
                let params = {
                    return_id: this.purchaseReturnData['return_id'],
                    model_id: this.returngriddata['model_id'],
                    serial_no: this.returngriddata['serial_no'],
                    qty: this.returngriddata['qty'],
                    mrp: this.returngriddata['mrp'],
                    total_amount: this.returngriddata['total_amount'],
                    name: this.returngriddata['name'],
                    brand_name : this.returngriddata['brand_name'],
                    brand_model_name : this.returngriddata['brand_model_name'],
                    family_name : this.returngriddata['family_name'],
                    series_name : this.returngriddata['series_name'],
                    performance_name : this.returngriddata['performance_name'],
                    power_name : this.returngriddata['power_name'],
                    battery_name : this.returngriddata['battery_name'],
                    color_name : this.returngriddata['color_name'],
                    color_id : this.returngriddata['color_id'],
                    tele_audiology : this.returngriddata['tele_audiology'],
                    brand_id : this.returngriddata['brand_id'],
                    brand_model_id : this.returngriddata['brand_model_id'],
                    family_id : this.returngriddata['family_id'],
                    series_id : this.returngriddata['series_id'],
                    performance_id : this.returngriddata['performance_id'],
                    power_id : this.returngriddata['power_id'],
                    battery_id : this.returngriddata['battery_id']
                },
                    testDet = Object.assign({}, this.returngriddata);

                this.purchaseReturnService
                    .addPurchaseReturn(params)
                    .then(function(res: any) {
                        that.isLoading = false;

                        if (res.success) {
                            swal('SUCCESS', res.message, 'success');
                            
                            that.purchaseReturnDetails.push(testDet);
                            that.calGrossTotal();
                            that.returngriddata = [];
                            that.page.count = that.purchaseReturnDetails.length;
                        } else {
                            swal('ERROR', res.message, 'error');
                        }
                    })
            }
            else if (mode == 'View') {
                let params = {
                    return_id: this.purchaseReturnData['return_id'],
                    model_id: this.returngriddata['model_id'],
                    serial_no: this.returngriddata['serial_no'],
                    qty: this.returngriddata['qty'],
                    mrp: this.returngriddata['mrp'],
                    total_amount: this.returngriddata['total_amount'],
                    name: this.returngriddata['name'],
                    brand_name : this.returngriddata['brand_name'],
                    brand_model_name : this.returngriddata['brand_model_name'],
                    family_name : this.returngriddata['family_name'],
                    series_name : this.returngriddata['series_name'],
                    performance_name : this.returngriddata['performance_name'],
                    power_name : this.returngriddata['power_name'],
                    battery_name : this.returngriddata['battery_name'],
                    color_name : this.returngriddata['color_name'],
                    color_id : this.returngriddata['color_id'],
                    tele_audiology : this.returngriddata['tele_audiology'],
                    brand_id : this.returngriddata['brand_id'],
                    brand_model_id : this.returngriddata['brand_model_id'],
                    family_id : this.returngriddata['family_id'],
                    series_id : this.returngriddata['series_id'],
                    performance_id : this.returngriddata['performance_id'],
                    power_id : this.returngriddata['power_id'],
                    battery_id : this.returngriddata['battery_id']
                },
                    testDet = Object.assign({}, this.returngriddata);
            }
            return;
        }

    }

   calAmount() {
        let qty = this.returngriddata['qty'],
            mrp = this.returngriddata['mrp'],
            amt = 0;

        if (!_.isEmpty(_.toString(mrp))) {
            amt = (qty * mrp);
        }
        this.returngriddata['total_amount'] = amt;
    }
     calGrossTotal() {
        let gross_total = 0;


        for (let i = 0; i < this.purchaseReturnDetails.length; i++) {
            let total_amount = this.purchaseReturnDetails[i].total_amount;
            gross_total += Number(total_amount);
           

        }
        this.purchaseReturnData['gross_total'] = gross_total;
  
    }
    onSavePurchaseReturn() {
        let that = this,
            mode = this._params['mode'],
            testingDet = this.purchaseReturnDetails.length,
            quantity = 0,
            amt = 0,
            toast = {
                type: 'warning',
                title: 'WARNING'
            };

        if (testingDet == 0) {
            swal('WARNING', 'No Data Found, <br> Please Add Purchase Details');
            return;
        }

        for (let i = 0; i < testingDet; i++) {
             quantity+= parseFloat((this.purchaseReturnDetails[i].qty));
        }
        

        let returnDate = moment(this.purchaseReturnData['date']).format('YYYY-MM-DD'),
            purchaseDate = moment(this.purchaseReturnData['purchase_date']).format('YYYY-MM-DD'),
            data = {
                return_id: this.purchaseReturnData['return_id'],
                auto_no: this.purchaseReturnData['auto_no'],
                purchase_id:  this.purchaseReturnData['purchase_id'],
                purchase_no: this.purchaseReturnData['purchase_no'],
                date: returnDate,
                purchase_date: purchaseDate,
                purchaseReturnDetails: JSON.stringify(this.purchaseReturnDetails),
                description: this.purchaseReturnData['description'],
                party_id: this.purchaseReturnData['party_id'],
                mode: this._params['mode'],
                amount:  this.purchaseReturnData['gross_total'],
                total_qty:quantity
            };

        this.isLoading = true;

        this.purchaseReturnService
            .addSavePurchaseReturn(data)
            .then(function(res: any) {
                that.isLoading = false;
                if (res.success) {
                    swal('SUCCESS', res.message, 'success');
                    that.subscribeService.subScribeDeleteActiveTab();
                    that.subscribeService.subReloadServiceGrid();
                    that.purchaseReturnData = [];
                    that.purchaseReturnDetails = [];
                } else {
                    swal('ERROR', res.message, 'error');
                }
            })
            .catch(function(error: any) {
                that.isLoading = false;
                let res = JSON.parse(error._body);
                swal('ERROR', res.message, 'error');
                //console.log(error);
            });

    }
}



// WEBPACK FOOTER //
// /Applications/MAMP/htdocs/crm-soundsgood/src/app/components/transaction/purchaseReturn/addPurchaseReturn.component.ts